import React, { useState, useEffect } from 'react'
import { Button, Form, FormGroup, Label, Input, Row, Col } from 'reactstrap'
import ApiService from '../../../data/services/ApiService'
import Select from "react-select"
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

const Export = ({ isOpen, setLoading, onExport }) => {
    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const [customerIds, setCustomerIds] = useState()
    const [customers, setCustomers] = useState([])

    useEffect(() => {
        (async () => {
            await fetchCustomers()
        })()
    }, []) // eslint-disable-line

     async function fetchCustomers() {
        try {
            setLoading(true)
            const response = await ApiService.getCustomers()
            let customers = []

            response.data.customers.map((item) => {
                return customers.push({
                    value: item.id,
                    label: item.businessName
                })
            })

            setCustomers(customers)
        } catch (error) {
            console.log(error)
            toastr.error(`I couldn't fetch your customers`)
        } finally {
            setLoading(false)
        }
    }

    const handleExport = (e) => {
        e.preventDefault()
        onExport({ startDate, endDate, customerIds: customerIds ? customerIds.map(c => c.value ) : null })
    }

    return (
        <div className={`sidemodal${isOpen ? ' open' : ''}`}>
            <Form onSubmit={handleExport} className="p-3">
                <Row>
                    <Col sm={12} md={6}>
                        <FormGroup>
                            <Label for="startDate">Fecha inicio</Label>
                            <Input type="date" id="startDate" value={startDate} onChange={e => setStartDate(e.target.value)} />
                        </FormGroup>
                    </Col>
                    <Col sm={12} md={6}>
                        <FormGroup>
                            <Label for="endDate">Fecha fin</Label>
                            <Input type="date" id="endDate" value={endDate} onChange={e => setEndDate(e.target.value)} />
                        </FormGroup>
                    </Col>

                    <Col sm={12} md={12}>
                        <FormGroup>
                            <Label>Clientes</Label>

                            <Select
                                value={customerIds}
                                defaultValue={customerIds}
                                placeholder="Clientes..."
                                isMulti={true}
                                onChange={(value) => {
                                    setCustomerIds(value)
                                }}
                                options={customers}
                                classNamePrefix="select2-selection"
                            />
                        </FormGroup>
                    </Col>
                    <Col sm={12} md={6}>
                        
                    </Col>
                </Row>
                
                <Row className="mt-4">
                    <Col>
                        <Button color="primary" type="submit" block>Exportar</Button>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}

export default Export
